import { useEffect } from 'react';

type PreloaderBridge = { mount: () => void; ready: () => void };

declare global {
  interface Window {
    __mtPreloader?: PreloaderBridge;
  }
}

type SitePreloaderProps = {
  /** Сессия кабинета и CSRF готовы. На myteacher.pro тот же шлюз - событие load. */
  appReady?: boolean;
};

/**
 * Прелоадер кабинета = прелоадер myteacher.pro 1:1. Разметка и CSS лежат статически в index.html
 * (собраны из myteacher.pro SitePreloader.module.scss), поэтому анимация стартует до загрузки JS,
 * как SSR-разметка на myteacher. Компонент только сообщает сценарию о старте и готовности приложения.
 */
export function SitePreloader({ appReady = true }: SitePreloaderProps) {
  useEffect(() => {
    window.__mtPreloader?.mount();
  }, []);

  useEffect(() => {
    if (appReady) window.__mtPreloader?.ready();
  }, [appReady]);

  return null;
}

export default SitePreloader;
